import type { Offer } from "@types_def/models/offer.types";
import type { FunctionComponent } from "react";

export const DriverNameCell: FunctionComponent = ({ children }) => {
  const fullName = `${(children as Offer)?.driver?.firstName} ${(children as Offer)?.driver?.lastName}`;
  return fullName ? fullName : <></>;
};
